import { useEffect, useRef, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { patientSelector } from 'redux/slices/patient/patient.selector';
import { WellnubDateInput } from '@wellnub/web-common';

import { Box, CircularProgress, Grid, Typography } from '@material-ui/core';
import { useFileUploader } from 'hooks/fileUpload.hook';
import { useAddNutritionalPlan } from 'hooks/patient.hook';

import { useAnalyticsEventTracker } from 'hooks/analytics.hook';
import Button from '../../Button/Button.component';

const AddNutritionalPlanForm = () => {
  const [fileUrl, setFileUrl] = useState('');
  const fileRef = useRef(null);

  const wnPatient = useSelector(patientSelector);

  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      startDate: new Date(),
      endDate: new Date(),
    },
  });

  const { mutateAsync, isLoading: isLoadingFile } = useFileUploader();
  const { mutate, isLoading, isSuccess } = useAddNutritionalPlan();

  const { enqueueSnackbar } = useSnackbar();

  const { eventTracker } = useAnalyticsEventTracker('nutritionist-action');

  let formData = new FormData();

  const onSubmitHandler = async data => {
    const { startDate, endDate } = data;
    const payload = {
      patient: wnPatient._id,
      startDate,
      endDate,
      fileUrl,
    };
    mutate(payload);
    eventTracker('submit-nutrititional-plan', 'nutritional-plan-sended');
  };

  const onChangeFileHandler = e => {
    if (e.target && e.target.files[0]) {
      formData.append('file', e.target.files[0]);
      mutateAsync(formData)
        .then(response => {
          setFileUrl(response.fileUrl);
        })
        .catch(() => {
          enqueueSnackbar('Algo salió mal, intenta más tarde', {
            variant: 'error',
          });
        });
    }
  };

  useEffect(() => {
    if (isSuccess) {
      reset();
      fileRef.current.value = '';
    }
  }, [isSuccess, reset]);

  return (
    <form onSubmit={handleSubmit(onSubmitHandler)}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <WellnubDateInput
            name="startDate"
            inputVariant="outlined"
            rules={{
              required: 'Este campo es requerido',
            }}
            format="dd/MM/yyyy"
            label="Fecha inicio*"
            control={control}
            helperText="Fecha de inicio del plan"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <WellnubDateInput
            name="endDate"
            inputVariant="outlined"
            rules={{
              required: 'Este campo es requerido',
            }}
            format="dd/MM/yyyy"
            label="Fecha final*"
            control={control}
            helperText="Fecha de terminación del plan"
          />
        </Grid>
        <Grid item sm={4}>
          <Typography variant="caption" style={{ paddingBottom: 8 }}>
            Agregar archivo*
          </Typography>
          <input
            required
            ref={fileRef}
            type="file"
            id="fileInput"
            accept="image/*,.pdf"
            onChange={onChangeFileHandler}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="caption">* Campos obligatorios</Typography>
        </Grid>
      </Grid>
      <Box mt={2} textAlign="right">
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={isLoading || isLoadingFile}
        >
          {isLoadingFile ? (
            <>
              <span>Cargando</span>
              <CircularProgress size={22} />
            </>
          ) : (
            'Agregar'
          )}
        </Button>
      </Box>
    </form>
  );
};

export default AddNutritionalPlanForm;
